.Decks {
    position: absolute;
    top: 20px;
    right: 20px;
    height: calc(100% - 40px);
    width: 300px;
    background-color: var(--primary);
    border-radius: 12px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    overflow-y: auto;
    z-index: 1000;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.decksHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    position: relative;

    h2 {
        margin: 0;
        color: var(--primary-foreground);
        font-size: 20px;
        font-weight: 600;
    }
}

.closeButton {
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease;

    &:hover {
        background: rgba(0, 0, 0, 0.1);
    }
}

.deck {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    padding: 16px;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        background: rgba(0, 0, 0, 0.08);
    }
}

.deckHeader {
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    > div:first-child {
        display: flex;
        // space between the items
        justify-content: space-between;
    }

    h3 {
        margin: 0;
        color: var(--primary-foreground);
        font-size: 18px;
        font-weight: 600;
    }
}

.removeButton {
    background: rgba(255, 59, 48, 0.8);
    border: none;
    border-radius: 6px;
    color: white;
    padding: 6px 12px;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: rgba(255, 59, 48, 1);
        transform: scale(1.05);
    }
}

.deck p {
    color: rgba(51, 51, 51, 0.8);
    margin: 0 0 12px 0;
    font-size: 14px;
    line-height: 1.4;
}

.cards {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 12px;
}

.card {
    border-radius: 6px;
    transition: all 0.2s ease;
    font-size: 12px;

    &:hover {
        background: rgba(0, 0, 0, 0.06);
    }
}

.cardFront,
.cardBack {
    color: var(--primary-foreground);
    font-size: 13px;
    margin: 4px 0;

    strong {
        color: rgba(51, 51, 51, 0.9);
        font-weight: 600;
    }
}

.AddCard {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;

    input {
        background: rgba(0, 0, 0, 0.05);
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 6px;
        padding: 8px 12px;
        color: var(--primary-foreground);
        font-size: 14px;
        transition: all 0.2s ease;

        &::placeholder {
            color: rgba(51, 51, 51, 0.6);
        }

        &:focus {
            outline: none;
            border-color: rgba(0, 122, 255, 0.6);
            background: rgba(0, 0, 0, 0.1);
        }
    }
}

.addCardButton {
    background: rgba(52, 199, 89, 0.8);
    border: none;
    border-radius: 6px;
    color: white;
    padding: 10px 16px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
        background: rgba(52, 199, 89, 1);
        transform: translateY(-1px);
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}

.AddDeck {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    background: rgba(0, 0, 0, 0.03);
    border-radius: 8px;
    border: 2px dashed rgba(0, 0, 0, 0.2);

    input {
        background: rgba(0, 0, 0, 0.05);
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 6px;
        padding: 12px 16px;
        color: var(--primary-foreground);
        font-size: 16px;
        transition: all 0.2s ease;

        &::placeholder {
            color: rgba(51, 51, 51, 0.6);
        }

        &:focus {
            outline: none;
            border-color: rgba(0, 122, 255, 0.6);
            background: rgba(0, 0, 0, 0.1);
        }
    }
}

.addDeckButton {
    background: rgba(0, 122, 255, 0.8);
    border: none;
    border-radius: 6px;
    color: white;
    padding: 12px 20px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
        background: rgba(0, 122, 255, 1);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 122, 255, 0.3);
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}
